import { Block } from 'components/Block'
import {
  GuidebookStep,
  stepDigitalLegacyLinkProps as stepDigitalLegacyData,
} from 'components/content/guidebook/content'
import { SGridWrapper } from './GuidebookStepDigitalLegacy.styled'
import { GuidebookStepHeader } from 'components/content/guidebook/guidebookStepHeader/GuidebookStepHeader'
import { HighlightedParagraph } from 'components/highlightedParagraph/HighlightedParagraph'
import { Picture } from 'components/picture/Picture'
import { useTranslation } from 'next-i18next'
import { numberRange } from 'utils/general'

export function GuidebookStepDigitalLegacy(props: { step: GuidebookStep }) {
  const { t } = useTranslation('eol_guide')
  const { t: tCommon } = useTranslation()

  return (
    <>
      <GuidebookStepHeader
        step={props.step}
        description={t('eol_guide.step_2.description')}
        image={<Picture imageKey={'illustrations/safe'} />}
      />
      <Block>
        <SGridWrapper>
          {numberRange(2).map((i) => (
            <HighlightedParagraph
              key={i}
              title={t(`eol_guide.step_2.item_${i}.title`)}
              description={t(`eol_guide.step_2.item_${i}.description`)}
              actionLabel={tCommon('common.learn_more')}
              {...stepDigitalLegacyData[i]}
            />
          ))}
        </SGridWrapper>
      </Block>
    </>
  )
}
